import { strPeriodToFormattedDate } from '../../../common/utils';
import { PERIOD, CHART_COLOURS as COLORS } from '../../../common/constants';
import { numberWithCommas } from '../../../common/utils';

export const transformTags = (topTags, colourCode) => {
    if (topTags && topTags.length) {
        return topTags.map((topTag, index) => {
            return {
                tag: topTag.tag,
                count: parseInt(topTag.count),
                color:
                    colourCode == 'orange'
                        ? COLORS.ORANGE[index % COLORS.ORANGE.length]
                        : COLORS.BLUE[index % COLORS.BLUE.length],
            };
        });
    } else {
        return [];
    }
};

export const transformActivity = (activityState) => {
    if (activityState && activityState.length) {
        return activityState.map((activity) => {
            return {
                month: activity.text.slice(0, 3).toUpperCase(),
                count: parseInt(activity.total),
            };
        });
    } else {
        return [];
    }
};

export const transformContributors = (contributorsState) => {
    if (contributorsState && contributorsState.length) {
        return contributorsState.map((contributor) => {
            return {
                id: contributor.id,
                fullName: contributor.fullName,
                profilePicture: contributor.profilePicture,
                litters: contributor.litters
                    ? numberWithCommas(contributor.litters)
                    : '--',
            };
        });
    } else {
        return [];
    }
};

export const transformContributorsTeam = (contributorsState) => {
    if (contributorsState && contributorsState.length) {
        return contributorsState.map((contributor) => {
            return {
                id: contributor.id,
                fullName: contributor.code,
                profilePicture:
                    'https://litterati-avatars-prod.s3-us-west-2.amazonaws.com/users/user-default/profile-picture-sky-blue.png',
                litters: contributor.totalLitters
                    ? numberWithCommas(contributor.totalLitters)
                    : 0,
            };
        });
    } else {
        return [];
    }
};

export const transformSelectDate = (dateState, customDate) => {
    if (dateState) {
        const endDate =
            dateState === PERIOD.CUSTOM
                ? strPeriodToFormattedDate(PERIOD.CUSTOM_END, null, customDate)
                : dateState === PERIOD.LAST_YEAR
                ? strPeriodToFormattedDate(PERIOD.LAST_YEAR_END)
                : strPeriodToFormattedDate(PERIOD.END_TODAY);
        return {
            startDate:
                dateState === PERIOD.CUSTOM
                    ? strPeriodToFormattedDate(
                          PERIOD.CUSTOM_START,
                          null,
                          customDate,
                      )
                    : strPeriodToFormattedDate(dateState), // empty format will use ISO8601 by default
            endDate,
        };
    } else {
        return '';
    }
};
